import React from "react";

export const UnauthorizedAccess: React.FC = () => (
  <div className="flex h-[100vh] flex-col items-center justify-center text-center">
    <svg
      className="mb-4 h-16 w-16 text-red-500"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 15v2m0 0v2m0-2h2m-2 0H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    <h2 className="mb-2 text-2xl font-bold text-zinc-800">
      Acesso Não Autorizado
    </h2>
    <p className="mb-4 text-zinc-600">
      Você não tem permissão para acessar esta área.
    </p>
    <p className="text-zinc-500">
      Por favor, entre em contato com um administrador.
    </p>
  </div>
);
